import { createSlice } from '@reduxjs/toolkit';
import type { TechnicalDataResponse } from '~/api/responseTypes/technical-data-response-data';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import TechnicalDataAPI from '~/api/technical-data-api';
import { initialState } from './data/TechnicalDataState';

export const getTechnicalData = createCaughtAsyncThunk<
  TechnicalDataResponse,
  { assetId: AssetId }
>('getTechnicalData', async (args) => {
  return await TechnicalDataAPI.getTechnicalData(args.assetId);
});

const slice = createSlice({
  name: 'technical-data',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTechnicalData.pending, (state) => {
        state.isLoading = true;
        delete state.error;
      })
      .addCase(getTechnicalData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload.categories;
      })
      .addCase(getTechnicalData.rejected, (state, action) => {
        if (action.meta.aborted) {
          return;
        }
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetState } = slice.actions;
export default slice.reducer;
